export enum EMultibundle {
    VAS_MULTIBUNDLE = 'VAS_MULTIBUNDLE',
    VAS_MULTIBUNDLE_SET_STAGE = 'VAS_MULTIBUNDLE_SET_STAGE',
    POPUP_MULTIBUNDLE_SET = 'POPUP_MULTIBUNDLE_SET',
    POPUP_MULTIBUNDLE_SET_CLOSED = 'POPUP_MULTIBUNDLE_SET_CLOSED',
    SUBSCRIBE_INFO_SET = 'SUBSCRIBE_INFO_SET',
    SUBSCRIBE_PHONE_INFO_SET = 'SUBSCRIBE_PHONE_INFO_SET',
}
